export enum DimensionType {
  Hierarchy,
  CalendarAQMW, // Annual Quarter Month Week
  CalendarAQM, // Annual Quarter Month 
  CalendarAnnual,
  CalendarWeek,
  BaseIndexAQMW, // Annual Quarter Month Week
  BaseIndexAQM, // Annual Quarter Month
  BaseIndexAnnual,
  DynamicDateRangeAQMW,
  DynamicDateRangeAQM,
  DynamicDateRangeAnnual,
  DynamicDateRangeWeek,
  DynamicDateRangeAQMWD,
  CalendarDay,
  Configuration = 1000,

  // Fake dimension for DynamicDateRange
  Frequency = 1001,
}